import Services from './Services';
import ServicesMock from './ServicesMock';

let isMockingService = process.env.NODE_ENV !== 'production';
if (process.env.VUE_APP_SERVICES === 'enabled') {
  isMockingService = false;
}
export default isMockingService ? ServicesMock : Services;